<form [formGroup]="form" class="style-form">
     <div style="display: flex;">
         <p class="inputRadio">¿Acción autorizada?</p>
        <mat-radio-group style="margin-left: 60px;" formControlName="accion_autorizada" aria-label="Select an option">
            <mat-radio-button value="Si">Si</mat-radio-button>
            <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
          </mat-radio-group>
     </div>
</form>
